
import React, { useState } from 'react';

export function OptimizedImage({ 
  src, 
  alt, 
  className = '', 
  width, 
  height, 
  priority = false,
  fetchpriority,
  fallback = '/placeholder-product.png',
  ...props 
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    setCurrentSrc(fallback);
  };

  // Generate WebP source if supported
  const getOptimizedSrc = (originalSrc) => {
    if (!originalSrc || originalSrc.includes('placeholder')) return originalSrc;
    
    // For Amazon images, we can't convert but we can optimize sizing
    if (originalSrc.includes('amazon')) {
      return originalSrc;
    }
    
    return originalSrc;
  };

  return (
    <div className={`relative ${className}`}>
      {isLoading && !hasError && (
        <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" />
      )}
      
      <img
        src={getOptimizedSrc(currentSrc)}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? 'eager' : 'lazy'}
        fetchpriority={fetchpriority || (priority ? 'high' : undefined)}
        decoding="async"
        onLoad={handleLoad}
        onError={handleError}
        className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
        {...props}
      />
    </div>
  );
}
